import Dbm from "dbm";
import Website from "../../../index.js";

export default class MovingGraphic extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("sprite", null);
        this.item.setValue("speed", 1);
        this.item.setValue("zIndexBy", "speed");

        this.item.setValue("x", 0);
        this.item.setValue("y", 0);

        this.item.setValue("width", 0);
    }

    setup(aTexture, aAtBottom = true) {
        let sprite = new PIXI.Sprite(aTexture);

        this.item.width = aTexture.width;

        if(aAtBottom) {
            sprite.anchor.set(0.5, 1);
        }
        else {
            sprite.anchor.set(0.5, 0);
        }

        this.item.sprite = sprite;
        this.item.pixiLayer.addChild(sprite);

        return this;
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("update");

        this.item.pixiLayer.x = this.getScreenPosition(aCameraPosition);
        this.item.pixiLayer.y = this.item.y;

        if(this.item.zIndexBy === "y") {
            this.item.pixiLayer.zIndex = this.item.y;
        }
        else if(this.item.zIndexBy === "speed") {
            this.item.pixiLayer.zIndex = Math.round(100*this.item.speed);
        }
    }

    getScreenPosition(aCameraPosition) {
        let distance = this.item.speed*(this.item.x - aCameraPosition);

        return distance + Website.game.Sizes.CENTER_X;
    }

    hasPassed(aCameraPosition) {
        let screenPosition = this.getScreenPosition(aCameraPosition);

        if(screenPosition+0.5*this.item.width < 0) {
            return true;
        }

        return false;
    }

    getNextOffscreenPosition(aCameraPosition) {
        return aCameraPosition + (Website.game.Sizes.CENTER_X+0.5*this.item.width)/this.item.speed;
    }
}